var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"organization-search"},[_c('tokens-manager',{attrs:{"organization-id":_vm.organization.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }